import React, { FunctionComponent } from 'react';
import { faNotesMedical } from '@fortawesome/free-solid-svg-icons';
import { BrassIcon, BrassIconProps } from '..';

const BrassIconMedicalExam: FunctionComponent<BrassIconProps> = (
  props: BrassIconProps,
) => <BrassIcon {...props} icon={faNotesMedical} />;

export { BrassIconMedicalExam };
